import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a59588c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 3 }
const _hoisted_2 = {
  key: 0,
  class: "manual-confirmation"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingModal = _resolveComponent("LoadingModal")!
  const _component_IncorrectTrailerQrScanOverlay = _resolveComponent("IncorrectTrailerQrScanOverlay")!
  const _component_ScanTrailer = _resolveComponent("ScanTrailer")!
  const _component_AttachTrailerConfirmation = _resolveComponent("AttachTrailerConfirmation")!
  const _component_TrailerPlateVinVerification = _resolveComponent("TrailerPlateVinVerification")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showLoading)
      ? (_openBlock(), _createBlock(_component_LoadingModal, {
          key: 0,
          isFullScreen: true
        }))
      : _createCommentVNode("", true),
    (_ctx.isIncorrectTrailerScan)
      ? (_openBlock(), _createBlock(_component_IncorrectTrailerQrScanOverlay, {
          key: 1,
          attachingTrailerNumber: _ctx.trailer.trailerNumber,
          onOnGoBack: _ctx.closeVerification
        }, null, 8, ["attachingTrailerNumber", "onOnGoBack"]))
      : _createCommentVNode("", true),
    (_ctx.showScanner)
      ? (_openBlock(), _createBlock(_component_ScanTrailer, {
          key: 2,
          isScannerPaused: _ctx.isScannerPaused,
          onOnCloseScanner: _ctx.closeVerification,
          onOnManualAttach: _ctx.enablePlateVin,
          onOnScanned: _ctx.validateScannedTrailer,
          onOnScanError: _ctx.enablePlateVin
        }, null, 8, ["isScannerPaused", "onOnCloseScanner", "onOnManualAttach", "onOnScanned", "onOnScanError"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.showAttachConfirm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_AttachTrailerConfirmation, {
                  trailerNumber: _ctx.trailerToVerify.trailerNumber,
                  trailerCompany: _ctx.trailerToVerify.company,
                  onAccept: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAttachConfirm = false)),
                  onReject: _ctx.closeVerification
                }, null, 8, ["trailerNumber", "trailerCompany", "onReject"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_TrailerPlateVinVerification, {
            trailer: _ctx.trailerToVerify,
            proximity: _ctx.distance,
            onAttachVerified: _ctx.verifiedPlateOrVin,
            onGoBack: _ctx.closeVerification
          }, null, 8, ["trailer", "proximity", "onAttachVerified", "onGoBack"])
        ]))
  ]))
}